<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500"></div></div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-6">

      <!-- Sección: Identificación -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Identificación</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2">
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Etiqueta visible <span class="text-error-500">*</span>
            </label>
            <input type="text" formControlName="label"
              (input)="onLabelInput($any($event.target).value)"
              placeholder="Ej. Llamar al cliente"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              [class.border-error-500]="hasError('label')" [class.border-gray-300]="!hasError('label')"/>
            <p class="mt-1 text-xs text-gray-500">Lo que verán los usuarios al crear una tarea.</p>
            @if (hasError('label')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('label') }}</p> }
          </div>

          <div class="md:col-span-2">
            <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Código interno <span class="text-error-500">*</span>
            </label>
            <input type="text" formControlName="name"
              (input)="onNameInput()"
              placeholder="LLAMAR_AL_CLIENTE"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 uppercase font-mono focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
              [class.border-error-500]="hasError('name')" [class.border-gray-300]="!hasError('name')"/>
            <p class="mt-1 text-xs text-gray-500">Se completa automáticamente desde la etiqueta. Mayúsculas y guiones bajos. Lo usan integraciones — cámbialo solo si sabes lo que haces.</p>
            @if (hasError('name')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p> }
          </div>
        </div>
      </section>

      <!-- Sección: Apariencia -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Apariencia</h3>

        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Color</label>

          <div class="flex flex-wrap gap-2 mb-3">
            @for (c of COLOR_PRESETS; track c) {
              <button type="button" (click)="setColor(c)"
                class="w-8 h-8 rounded-lg border-2 transition-all hover:scale-110"
                [style.background-color]="c"
                [class.border-gray-900]="form.value.color === c"
                [class.dark:border-white]="form.value.color === c"
                [class.border-transparent]="form.value.color !== c"
                [title]="c">
              </button>
            }
          </div>

          <div class="flex items-center gap-3">
            <div class="relative">
              <input type="color" formControlName="color"
                class="absolute inset-0 w-12 h-12 opacity-0 cursor-pointer"
                title="Selector de color"/>
              <div class="w-12 h-12 rounded-lg border-2 border-gray-200 dark:border-gray-700 shadow-sm pointer-events-none"
                [style.background-color]="form.value.color || '#4CAF50'"></div>
            </div>
            <input type="text" formControlName="color" placeholder="#4CAF50"
              class="flex-1 h-11 rounded-lg border border-gray-300 bg-transparent px-3 text-sm font-mono uppercase dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"/>
          </div>
        </div>

      </section>

      <!-- Sección: Configuración -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Configuración</h3>

        <!-- Switch: Activo -->
        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isActive" class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-brand-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Tipo activo</span>
            <span class="block text-xs text-gray-500">Si está desactivado, no aparecerá en los selectores al crear nuevas tareas.</span>
          </div>
        </label>
      </section>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
